var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"header"},[_vm._t("header")],2),_c('Navbar'),_c('Loader',{attrs:{"show":_vm.loading}}),(!_vm.loading)?_c('div',{attrs:{"sticky-container":""}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }